import { createContext } from 'react';
import { useWizardNavigation } from '../hooks/useWizardNavigation';

export const WizardContext = createContext<{
  state?: Record<string, unknown>;
  updateState?: (state: Record<string, unknown>) => void;
  navigation: ReturnType<typeof useWizardNavigation>;
}>({
  state: {},
  updateState: () => void 0,
  navigation: {
    activeSection: '',
    updateEntityState: () => void 0,
    goToNext: () => void 0,
    goToPrev: () => void 0,
    goTo: () => void 0,
    hidePane: () => void 0,
    toggleSection: () => void 0,
    query: new URLSearchParams(),
    groupId: '',
    campaignId: '',
    activeCampaign: '',
    activePane: '',
    hasNext: false,
    hasPrev: false,
    nextSectionIndex: 0,
    prevSectionIndex: 0,
    nextSection: '',
    prevSection: '',
  },
});
